// SPDX-License-Identifier: AGPL-3.0-or-later

import {useLayoutEffect, useRef} from 'react';

export function useLatestRef<T>(value: T) {
	const ref = useRef(value);
	useLayoutEffect(() => {
		ref.current = value;
	}, [value]);
	return ref;
}
